import React, { useEffect, useState } from "react";
import { Outlet, useLoaderData, useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  getClientAccountByClientAccountID,
  getAllClientArticles,
  getClients,
} from "API/swesum";
import ClientAccountCard from "./clientaccountcard/ClientAccountCard";

export default function ClientAccount() {
  const { accountID } = useParams();
  const [loading, setLoading] = useState(true);
  const [clientAccount, setClientAccount] = useState({});
  const [clientArticles, setClientArticles] = useState([]);

  useEffect(() => {
    const asyncFetchData = async () => {
      setLoading(true);
      const clientAccount = await getClientAccountByClientAccountID(accountID);
      const clientArticles = await getAllClientArticles();

      setClientAccount(clientAccount);
      setClientArticles(clientArticles);
      setLoading(false);
    };
    asyncFetchData();
  }, [accountID]);

  if (loading) {
    return null;
  }
  return (
    <>
      {/* <Drawer menuItems={menuItems}> */}
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {`Klientkonto -`} {clientAccount.Id}
          </Typography>
          <ClientAccountCard
            clientAccount={clientAccount}
            clientArticles={clientArticles}
          />
        </Box>
      </Box>
      {/* </Drawer> */}
    </>
  );
}
